var ROUTE_GLOB_PATTERN = "**/*.{ts,tsx}";
var API_ROUTE_GLOB_PATTERN = "**/*+api.{ts,tsx}";
var ROUTE_WEB_EXCLUSION_GLOB_PATTERNS = [
  "**/*.native.{ts,tsx}",
  "**/*.ios.{ts,tsx}",
  "**/*.android.{ts,tsx}"
];
var ROUTE_NATIVE_EXCLUSION_GLOB_PATTERNS = [
  "**/*.web.{ts,tsx}"
];
export {
  API_ROUTE_GLOB_PATTERN,
  ROUTE_GLOB_PATTERN,
  ROUTE_NATIVE_EXCLUSION_GLOB_PATTERNS,
  ROUTE_WEB_EXCLUSION_GLOB_PATTERNS
};
//# sourceMappingURL=glob-patterns.js.map
